import { site } from "../data/site";
import { SectionHeading } from "../components/common/SectionHeading";
import { additional } from "../data/additionalProjects";
import { ProjectRow } from "../components/projects/ProjectRow";
import { useProjectShelf } from "../hooks/useProjectShelf";
export function AdditionalProjects() {
  const { visible, loading, shelf, loadMore } = useProjectShelf(additional);
  return (
    <section
      className="archive-section shell"
      aria-labelledby="archive-heading"
    >
      <SectionHeading
        id="archive-heading"
        compact
        eyebrow="04 / MORE TO EXPLORE"
        title={
          <>
            The project shelf<span className="accent">.</span>
          </>
        }
        trailing={
          <a
            className="text-link"
            href={site.github}
            target="_blank"
            rel="noreferrer"
          >
            Browse GitHub ↗
          </a>
        }
      />
      <div className="archive-list" ref={shelf} id="project-shelf">
        {additional.slice(0, visible).map((project) => (
          <ProjectRow key={project.name} project={project} />
        ))}
      </div>
      <p className="sr-only" role="status">
        Showing {visible} of {additional.length} additional projects.
      </p>
      {visible < additional.length && (
        <button
          type="button"
          className="load-more"
          onClick={loadMore}
          disabled={loading}
          aria-busy={loading}
          aria-controls="project-shelf"
        >
          {loading ? "Loading projects…" : "Load more projects"}
          <span className={loading ? "spinner" : ""} aria-hidden="true">
            {loading ? "↻" : "+"}
          </span>
        </button>
      )}
    </section>
  );
}
